
export default function Action() {
  return (
    <div className="flex items-center gap-x-6 bg-gradient-to-r from-purple-800 to-indigo-700 text-left py-2.5 px-6 sm:px-3.5 sm:before:flex-1">
    <p className="text-sm leading-6 text-white">
      <a href="https://opensea.io/CryptonikasDAO/created" target="_blank">
        <strong className="font-semibold">Gen Cryptonikas</strong>
        <svg viewBox="0 0 2 2" className="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
          <circle cx={1} cy={1} r={1} />
        </svg>
        Visita nuestra colección en OpenSea
      </a>
    </p>
    <div className="flex flex-1 justify-end">
      <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]">
        <span className="sr-only">Dismiss</span>
      </button>
    </div>
  </div>
  )
}
